import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/Download";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import "./SubDealerRelation.scss";
import { API_URL_ADMIN, API_URL_LMS } from "../../../../Constant/index";
import Controls from "../Controls";
import { RenderCellExpand } from "../../../../components/datagridtooltip/DataGridToolTip";
import ExportExcelPopup from "../../../../components/exportPopup/ExportExcelPopup";
import Popup from "../../../../components/Popup/Popup";
import AddEditSubDealer from "./addEditSubDealer/AddEditSubDealer";
import DelSubDealer from "./delSubDealer/DeleteSubDealer";
import { getSubDealerRelationUnderSoldToAction } from "../../../../_actions/dealer.action";
import Axios from "axios";
import DataGridProMUI from "../../../../components/DataGrid/DataGridProMUI";
import { DataFormat } from "../../../../_helpers";
import { onExportExcel } from "../../../../_helpers/exportExcel";
import moment from "moment";
import { isPermission, authorizedMessage } from "../../../../_helpers/commonAPI";
import { ToastContainer, toast } from 'react-toastify';
import AuthorizedMessage from "../../../../components/AuthorizedMessage";
import Loader from "../../../../components/Loader/Loader";

export const SubDealerRelation = () => {
  const location = useLocation();
  const { accountName } = location.state;
  const { soldtoNumber } = location.state;
  const [openPopup, setOpenPopup] = useState(false);
  const [openEditPermissionPopup, setOpenEditPermissionPopup] = useState(null);
  const [openDeleteContactPopup, setOpenDeleteContactPopup] = useState(null);
  const [openExportPopup, setOpenExportPopup] = useState(null);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [recordForDelete, setRecordForDelete] = useState({});
  const [headerName, setHeaderName] = useState("Add Contact");
  const [rows, setRows] = useState([]);
  const Domhistory = useHistory();
  const [tableData, setTableData] = useState([]);
  const [pageSize, setPageSize] = useState(25);
  const [searchedRows, setSearchedRows] = useState(null)
  const [state, setState] = React.useState({
    message: "Deleted Successfully!!!!",
    severity: "success",
    open: false,
    editPermissionHdr: "",
  });
  const [fileUrl, setFileUrl] = useState("");
  const [exportFiles, setExportFiles] = useState([])
  const [open, setOpen] = useState(false);
  const [exportState, setExportState] = useState("Export");
  const dispatch = useDispatch();
  const SubDealerRelationUnderSoldToState = useSelector(
    (state) => state.SubDealerRelationUnderSoldTo
  );

  useEffect(() => {
    dispatch(getSubDealerRelationUnderSoldToAction(accountName));
  }, []);
  useEffect(() => {
    if (!openPopup && !openDeleteContactPopup && !openEditPermissionPopup) {
      dispatch(getSubDealerRelationUnderSoldToAction(accountName));
    }
  }, [openPopup, openDeleteContactPopup]);

  React.useEffect(() => {
    const filterData =
      SubDealerRelationUnderSoldToState &&
      SubDealerRelationUnderSoldToState.SubDealerRelationUnderSoldToList &&
      SubDealerRelationUnderSoldToState.SubDealerRelationUnderSoldToList.data &&
      SubDealerRelationUnderSoldToState.SubDealerRelationUnderSoldToList.data
        .length > 0 &&
      SubDealerRelationUnderSoldToState.SubDealerRelationUnderSoldToList.data.map(
        (e, i) => ({ ...e, index: i + 1, id: i + 1 })
      );
    setTableData(filterData);
  }, [SubDealerRelationUnderSoldToState]);

  const onExportClick = () => {
    const url = `export/subdealerlist-report`;
    setExportState("Exporting...");
    Axios({
      method: "POST",
      url: API_URL_ADMIN + url,
      data: { "soldToNumber": accountName },
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
        "X-SOLD-TO-ID": localStorage.getItem("CustomerNumber"),
      },
    })
      .then(async (response) => {
        setExportState("Export");
        setOpen(true);
        setFileUrl(response.data.data);
        exportExcelFile(response.data.data);
      })
      .catch((err) => {
        setExportState("Export");
      });
  };

  function exportExcelFile(file_url) {
    setExportFiles([]);
    Axios({
      method: "GET",
      url: API_URL_ADMIN + `export/bucket?folderName=${file_url}`,
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
        "X-SOLD-TO-ID": localStorage.getItem("CustomerNumber"),
      },
    })
      .then(async (response) => {
        const newRes = Array.isArray(response.data.data)
          ? response.data.data
          : [];
        setExportFiles(newRes);
      })
      .catch((err) => {
        // setExportState({ btnName: "EXPORT" });
      });
  }

  const columns = [
    {
      field: "actions",
      headerName: "Actions",
      headerAlign: "center",
      renderCell: (params) => {
        const findSelectedObj = () => {
          const api = params.api;
          const selectedRow = {};
          api
            .getAllColumns()
            .filter((c) => c.field !== "__check__" && !!c)
            .forEach(
              (c) =>
                (selectedRow[c.field] = params.getValue(params.id, c.field))
            );
          const selectedObject = rows.find(
            (item) => item.userName == selectedRow.userName
          );
          return selectedObject;
        };
        const onEditClick = async (e) => {
          const isAllow = await isPermission("SoldToManagement-SubDealerListwithRelationship-edit")
          if (!isAllow) {
            toast.success(authorizedMessage, {
              position: toast.POSITION.TOP_RIGHT
            });
            return 0;
          }
          let selectedObj = params.row;
          setHeaderName("Edit: No." + params.row.index);
          setRecordForEdit(selectedObj);
          setOpenPopup(true);
        };
        const onDeleteClick = async (e) => {
          let selectedObj = params.row;
          const isAllow = await isPermission("SoldToManagement-SubDealerListwithRelationship-delete")
          if (!isAllow) {
            toast.success(authorizedMessage, {
              position: toast.POSITION.TOP_RIGHT
            });
            return 0;
          }
          
          setRecordForDelete(selectedObj);
          setOpenDeleteContactPopup(true);
        };
        return (
          <>
            {params.row.deleted ? null : (
              <div className="Action">
                <EditIcon
                  className="EditIcon"
                  onClick={onEditClick}
                  sx={{ cursor: "pointer" }}
                />
                <DeleteIcon
                  className="DeleteIcon"
                  onClick={onDeleteClick}
                  sx={{ cursor: "pointer" }}
                />
              </div>
            )}
          </>
        );
      },
    },
    {
      field: "index",
      headerName: "No.",
      headerAlign: "center",
      align: "center",
      width: 50,
    },
    {
      field: "markDelete",
      headerName: "Mark Delete",
      align: "center",
      renderCell: (markDelete) => {
        return (
          <div className="MarkDelChkBox">
            <Controls.Checkbox value={markDelete.row.markDelete} />
          </div>
        );
      },
    },
    {
      field: "subdealerNumber",
      headerName: "Sub Dealer Number",
      headerAlign: "center",
      align: "center",
      width: 200,
      renderCell: RenderCellExpand,
      renderCell: ({ row }) => {
        const redirectToContact = (e) => {
          e.preventDefault();
          Domhistory.push(
            "/SubDealerManagement?subDelearNumber=" +
            row.subdealerNumber +
            "&subDelearName=" +
            row.subdealerNameEN
          );
        };
        return (
          <a href="#" onClick={redirectToContact}>
            {row.subdealerNumber ? DataFormat(row.subdealerNumber) : ""}
          </a>
        );
      },
    },
    {
      field: "subdealerNameEN",
      headerName: "Sub Dealer Name (EN)",
      headerAlign: "center",
      width: 200,
      renderCell: RenderCellExpand,
    },
    {
      field: "subdealerNameTH",
      headerName: "Sub Dealer Name (TH)",
      headerAlign: "center",
      width: 200,
      renderCell: RenderCellExpand,
    },
    {
      field: "relationStatus",
      headerName: "Relationship With Sub Dealer",
      headerAlign: "center",
      align: "center",
      width: 250,
    },
  ];

  function modifyColumns(columns) {
    columns = columns.filter(function (el) { return el.field != "actions"; });
    return columns.map((item) => {
      return ({
        label: item.headerName,
        value: item.field,
        ...item
      })
    })
  }

  function modifyRows(rowdata) {
    // let filteredRow = searchedRows.map((item) => item.model);
    let filteredRow = rowdata.map((item) => item.model);
    const data = filteredRow.map((item) => {
      return ({
        ...item
      })
    })
    return data
  }

  function callExcelExport(data) {
    const fileName = `SUBDEALER_LIST_WITH_RELATIONSHIP_${moment(new Date()).format("DDMMyyyy")}`;
    const sheetName = `SUBDEALER_LIST_WITH_RELATION`;
    onExportExcel(modifyColumns(columns), modifyRows(data), fileName, sheetName)
  }


  return (
    <>
      {SubDealerRelationUnderSoldToState && (SubDealerRelationUnderSoldToState.loading || SubDealerRelationUnderSoldToState.errorMessage === 401) ? SubDealerRelationUnderSoldToState.errorMessage === 401 ? <AuthorizedMessage /> : <Loader /> :
        <>
          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={state.open}
            autoHideDuration={6000}
            key={"topright"}
          >
            <Alert
              severity={state.severity}
              sx={{ width: "100%" }}
              action={
                <Button
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setState({ open: false });
                  }}
                >
                  Close
                </Button>
              }
            >
              {state.message}
            </Alert>
          </Snackbar>
          <div className="ContactContainer">
            <div className="AddAndSearch">
              <Button
                variant="contained"
                className="AddContactBtn"
                onClick={async() => {
                  const isAllow = await isPermission("SoldToManagement-SubDealerListwithRelationship-edit")
                  if (!isAllow) {
                    toast.success(authorizedMessage, {
                      position: toast.POSITION.TOP_RIGHT
                    });
                    return 0;
                  }

                  setHeaderName("Add Sub Dealer");
                  setOpenPopup(true);
                  setRecordForEdit(null);
                }}
              >
                ADD SUB DEALER
              </Button>
            </div>
          </div>
          <div className="DealerDataGridContainer">
            <ExportExcelPopup
              title={"Customer"}
              fileName={"customer"}
              setOpen={setOpen}
              open={open}
              exportExcelFile={exportExcelFile}
              fileUrl={fileUrl}
              exportFiles={exportFiles}
            />
            <DataGridProMUI
              rows={tableData ? tableData : []}
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              columns={columns}
              componentsProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
              getRowId={(r) => r.subdealerNumber}
              // ExpFilecolHeadings={ExpFilecolHeadings}
              // ExpFilecolKeys={ExpFilecolKeys}
              // ExportDateFormatIndexes={[]}
              // ExportFileName={"SubDealerRelationUnderSoldTO_" + accountName}
              loading={
                !(tableData || []).length &&
                SubDealerRelationUnderSoldToState.loading
              }
              onExportClick={onExportClick}
              exportState={exportState}
              setSearchedRows={setSearchedRows}
              callExcelExport={callExcelExport}
              defaultStateChange={false}
            />
          </div>
          <Popup
            title={headerName}
            openPopup={openPopup}
            setOpenPopup={setOpenPopup}
          >
            <AddEditSubDealer
              setOpenPopup={setOpenPopup}
              recordForEdit={recordForEdit}
            />
          </Popup>
          <Popup
            title={""}
            openPopup={openDeleteContactPopup}
            setOpenPopup={setOpenDeleteContactPopup}
          >
            <DelSubDealer
              openPopup={openDeleteContactPopup}
              setOpenPopup={setOpenDeleteContactPopup}
              recordForDelete={recordForDelete}
              setState={setState}
            />
          </Popup>
          <ToastContainer />
        </>
      }
    </>
  );
};
